/**
 * Browser cache for an organisation's call dispositions.
 *
 * Dispositions are static org configuration — there is no runtime editor — so
 * there is no need to refetch them every time the Call Disposition modal opens.
 * They are primed once at login, served from here, and cleared at logout /
 * session expiry. Keyed by org so a superadmin who switches organisations gets
 * the right list. Only non-empty lists are stored, so a transient empty result
 * (e.g. a momentary network blip) never sticks — the modal falls back to the
 * network and self-heals.
 *
 * All access is wrapped: localStorage can be full, disabled, or throw in private
 * mode, and the feature must degrade to a normal network fetch, never break.
 */
const PREFIX = 'dispositions:';
const keyFor = (orgId) => `${PREFIX}${orgId || 'self'}`;

export const readDispositionsCache = (orgId) => {
  try {
    const raw = localStorage.getItem(keyFor(orgId));
    if (!raw) return undefined; // undefined => React Query initialData is absent
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const writeDispositionsCache = (orgId, data) => {
  try {
    if (Array.isArray(data) && data.length) {
      localStorage.setItem(keyFor(orgId), JSON.stringify(data));
    }
  } catch {
    /* storage full / disabled — fall back to network next time */
  }
};

export const clearDispositionsCache = () => {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch {
    /* ignore */
  }
};
